function Tabs() {
	var self = this;
	self.init();
}

Tabs.prototype.init = function() {
	var self = this;

	function setActiveTab(e) {
		var id = $(e).attr('data-tab');
		$(e).addClass('-active');
		$(e).attr('aria-selected', 'true');
		$(e).siblings().removeClass('-active');
		$(e).siblings().attr('aria-selected', 'false');
		$(e).parent().parent().find('.catalogue-carousel-tabcontent').removeClass('-active');
		$(e).parent().parent().find('div[data-tabcontent='+id+']').addClass('-active');
		$(e).parent().parent().find('div[data-tabcontent='+id+'] .catalogue-carousel-body--activate').slick('refresh');
	}

	function switchTab(activeTab, direction) {
		const tabs = $('.catalogue-carousel-header__tab');
		let index = tabs.index(activeTab);

		if (direction === 'next') {
			index = (index + 1 >= tabs.length) ? 0 : index + 1;
		}
		if (direction === 'prev') {
			index = (index - 1 < 0) ? tabs.length - 1 : index - 1;
		}

		tabs[index].focus();
		tabs[index].click();
		tabs.attr('tabindex', '-1');
		$(tabs[index]).attr('tabindex', '0');
	}

	$('.catalogue-carousel-header__tab').click(function() {
		setActiveTab(this);
	});
	$('.catalogue-carousel-header__tab').on('keydown', function(e) {
		if (e.key === "ArrowLeft" || e.keyCode === 37) {
        	switchTab(this, 'prev');
		}
		if (e.key === "ArrowRight" || e.keyCode === 39) {
			switchTab(this, 'next');
		}
	});
};